import { render, staticRenderFns } from "./Passwordforgot.vue?vue&type=template&id=0e1d67a2&"
import script from "./Passwordforgot.vue?vue&type=script&lang=js&"
export * from "./Passwordforgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports